const init = () => {
	document.addEventListener('DOMContentLoaded', function () {
		document.getElementById('slider').style.display = 'flex';
		jQuery('.slide-main').slick({
			slide: 'li',
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplayspeed: 6000,
			pauseOnHover: false,
			pauseOnFocus: false,
			dots: true,
			arrows: true,
			infinite: true,
			responsive: [
				{
					breakpoint: 1010,
					settings: {
						arrows: false,
					},
				},
			],
		});
	});
};

export { init };
